import { Link } from "react-router-dom";
import { type Kind, PillToggleGroup } from "@norkron/web-review-workbench";
import type { DocStatus } from "../../api/types";
import { StatusBadge } from "../StatusBadge";
import { HashChip } from "../../compose/controls";
import { ArrowLeft } from "../../compose/Icon";

/**
 * `<WorkbenchBar>` — the sticky top bar of the Article Workbench (design §2.1):
 * back-to-Articles, the unit title, the `<StatusBadge>`, the head content-hash
 * chip (the delivery-gate signal), and the `<PillToggleGroup>` that toggles which
 * resources are shown. Reuses the `.docview__bar` look so the workbench sits in
 * the same chrome as the legacy viewer.
 */
export interface WorkbenchBarProps {
  readonly slug: string;
  readonly title: string;
  readonly status: DocStatus;
  readonly hash: string;
  readonly shown: readonly Kind[];
  readonly onShownChange: (next: Kind[]) => void;
  readonly onCopyHash?: () => void;
}

export function WorkbenchBar({
  slug,
  title,
  status,
  hash,
  shown,
  onShownChange,
  onCopyHash,
}: WorkbenchBarProps) {
  return (
    <div className="docview__bar wb-bar">
      <Link
        to={`/w/${slug}`}
        className="btn btn--ghost"
        data-testid="back-to-articles"
        style={{ padding: "6px 10px" }}
      >
        <ArrowLeft size={16} strokeWidth={1.5} />
        Articles
      </Link>
      <h1 className="docview__bar-title" data-testid="unit-title">
        {title}
      </h1>
      <StatusBadge status={status} />
      <HashChip hash={hash} onCopy={onCopyHash} />
      <div className="docview__bar-spacer" />
      <PillToggleGroup
        value={shown}
        onChange={onShownChange}
        ariaLabel="Show resources"
        testId="stage-pills"
      />
    </div>
  );
}
